import axios from 'axios';

const endpoint  = `${process.env.VUE_APP_BTOS_API}/logistika/get_container_by_external`;
const endpoint2 = `${process.env.VUE_APP_BTOS_API}/logistika/store_qr_from_ags`;
const endpoint3 = `${process.env.VUE_APP_BTOS_API}/logistika/store_permit_qr_ags`;
const endpoint4 = `${process.env.VUE_APP_BTOS_API}/logistika/get_container_information`;

const gateCorrection = (data) => {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${endpoint3}`,
    headers: { 
      'refererfe': 'pb.ags.co.id', 
      'Authorization': 'c2d951f3-3b08-4b3d-af8b-afbc447cf859_336448cc-8c28-40f1-ac16-be2c9e84bc4f'
    },
    data: JSON.stringify(data)
  };
  
  return axios.request(config)
    .then((response) => JSON.stringify(response.data))
    .catch((error) => {
      console.log(error);
    });
}

const rspValidateBtos = (data) => {
    // console.log(data);
    let direction = data.direction == 1 ? "IN" : "OUT";

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${endpoint}/${direction}/${data.container}/${data.status}`,
        headers: {
            'refererfe': 'pb.ags.co.id',
            'Authorization': 'c2d951f3-3b08-4b3d-af8b-afbc447cf859_336448cc-8c28-40f1-ac16-be2c9e84bc4f'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));

}

const rspQrCodeToBtos = (data) => {
    console.log('rspQrCodeToBtos');
    console.log(data);
    let direction = data.direction == 1 ? 'IN' : 'OUT';
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${endpoint2}/${direction}/${data.id}/${data.qr_code}/${data.exim}`,
        headers: { 
          'refererfe': 'pb.ags.co.id', 
          'Authorization': 'c2d951f3-3b08-4b3d-af8b-afbc447cf859_336448cc-8c28-40f1-ac16-be2c9e84bc4f'
        }
      };
      
    return axios.request(config)
      .then((response) => JSON.stringify(response.data))
      .catch((error) => {
        console.log(error);
      });

    // return data.id;
}

const getSavedPermit = (data) => {
  console.log(data);
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${endpoint4}`,
    headers: { 
      'refererfe': 'pb.ags.co.id', 
      'Authorization': 'c2d951f3-3b08-4b3d-af8b-afbc447cf859_336448cc-8c28-40f1-ac16-be2c9e84bc4f',
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  };
  
  return axios.request(config)
    .then((response) => JSON.stringify(response.data))
    .catch((error) => {
      console.log(error);
    });
}

export { rspValidateBtos, rspQrCodeToBtos, gateCorrection, getSavedPermit }